"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MNEMONIC = exports.QuillConst = void 0;
const constants_1 = require("../constants");
var QuillConst;
(function (QuillConst) {
    QuillConst["EmbedChar"] = "\n";
    QuillConst[QuillConst["EmbedSliceType"] = 0] = "EmbedSliceType";
})(QuillConst || (exports.QuillConst = QuillConst = {}));
exports.MNEMONIC = constants_1.ExtensionName[constants_1.ExtensionId.quill];
